import Header from "../../components/Header"
import TextField from "../../components/TextField"
import canadaFlag from "../../assets/CanadaFlag.jpg";
import { FIELD_ERROR_TEXT } from "../../utils";


const ApplicationInformation=(
    {
         data,
         handleInputChange,
          error,
          offlineDisabled
    }
)=>{

    return (
         <div >
         <Header text="Applicant Contact Information" />
           <div className="form_container" style={{paddingBottom : "0"}} >
             <TextField
                label="Name"
                 name="a_name"
                 required
                 value={data?.a_name}
                 handleChange={handleInputChange}
                  error_state={error?.a_name}
                   error_text={FIELD_ERROR_TEXT}
                    disabled={offlineDisabled}
               />

               <TextField
          label="Email Address"
          name="a_email"
          value={data?.a_email}
           handleChange={handleInputChange}
           custom="email"
           required
          error_state={error?.a_email}
          error_text={
            data?.a_email && error?.a_email
              ? "Please enter valid email" : FIELD_ERROR_TEXT
          }
           disabled={offlineDisabled}
        />
                <TextField
          label="Phone Number"
          name="a_phoneNumber"
          value={data?.a_phoneNumber}
           handleChange={handleInputChange}
          custom="phone"
          required
           error_state={error?.a_phoneNumber}
          error_text={
            data?.a_phoneNumber && error?.a_phoneNumber
              ? "Please enter valid phone"
              : FIELD_ERROR_TEXT
          }
           disabled={offlineDisabled}
          addonBefore={
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontSize: ".875rem",
                fontWeight: "600",
              }}
            >
              <img
                style={{ height: "0.75rem", opacity: "0.7" }}
                src={canadaFlag}
                alt=""
              />
              <span>+1</span>
            </div>
          }
        />
        </div>
        </div>
    )
     
}

export default ApplicationInformation